import _class from "./class.js";
import _assignment from "./assignment.js";
import _account from "./account.js";
import _exercise from "./exercise.js";
import _blogs from "./blogs.js";
import _form from "./form.js";
import _subscription from "./subscription.js";
import _schools from "./schools.js";
import _notifications from "./notifications.js";
import _tabuleoSubscription from "./tabuleoSubscription.js";
import _garSubscription from "./garSubscription.js";
import _students from "./students.js";
import _country from "./country.js";
import _teachers from "./teachers.js";
import _payment from "./payment.js";
import _resource from "./resource.js";
import _purge from "./purge.js";
import _mockExams from "./mockExams.js";
import _twoFactorAuth from "./twoFactorAuth.js";
import _session from "./session.js";
import _maintenance from "./maintenance.js";

const message = {
  languages: {
    language: "Langue",
    french: "Français",
    english: "Anglais",
    german: "Allemand",
  },
  notes: {
    helpNotePart1:
      "Note : cet exercice possède un mode aide que tu peux activer en cliquant sur le bouton ",
    helpNotePart2:
      "présent à côté de chaque question. Attention : si tu actives l’aide, tu n'obtiendras au maximum que la moitié des points de la question.",
  },
  bugCategories: {
    51: "Exercices",
    52: "Devoirs",
    53: "Compte personnel",
  },
  admin: "Administrateur",
  chapter: "Chapitre",
  subchapter: "Sous-chapitre",
  back: "Retour",
  backToContents: "Retour au sommaire",
  trainAgain: "S'entraîner encore",
  title: "Titre",
  talkingAboutUs: "ON PARLE DE NOUS",
  link: "Lien",
  text: "Texte",
  picture: "Image",
  keywords: "Mot-clés",
  firstname: "Prénom",
  lastname: "Nom",
  filterBy: "Filtrer par :",
  access: "Accéder",
  homeworkList: "Liste des devoirs",
  all: "Tous",
  accepted: "Accepté",
  notAccepted: "Non Accepté",
  commercialConsent: "Consentement Commercial",
  lastLogin: "Dernière connexion",
  email: "Adresse e-mail",
  publishDate: "Date de publication",
  modificationDate: "Date de modification",
  phone: "Téléphone",
  password: "Mot de passe",
  oldPassword: "Ancien mot de passe",
  newPassword: "Nouveau mot de passe",
  forgotPassword: "Mot de passe oublié ?",
  confirmPassword: "Confirmation du mot de passe",
  pswdHelp:
    "Le mot de passe doit contenir au moins 8 caractères et comporter au moins un caractère spécial.",
  receivingCommercial:
    "En cochant cette case, j'accepte de recevoir des communications commerciales de la part d'iizenglish.",
  termsAccepted: "J'accepte les",
  termsAndConditions: "conditions générales d'utilisation",
  termsAndConditionsAcceptedHelp:
    "Vous devez accepter les conditions générales d'utilisation.",
  registrationTitle: "Inscrivez-vous sur iizenglish",
  restPasswordTitle: "Ré-initialisez votre mot de passe !",
  resetPasswordRequested:
    "Votre demande de ré-initialisation de mot de passe à été bien prise en compte (le mail peut mettre jusqu'à une minute à arriver, vérifiez dans vos courriers indésirables).",
  submit: "Valider",
  loading: "Chargement",
  thanksJoining: "Merci de rejoindre iizenglish !",
  welcomeAdminHome: "Bienvenue sur l'espace d'administration",
  mailSent: "Un email vous a été envoyé",
  newMailSent: "Un nouvel email vous a été envoyé.",
  validationExpired:
    "Cette adresse de validation a expiré. Renseignez de nouveau votre mail :",
  requestExpired: "Votre demande a expiré.",
  signup: "Créer un compte",
  login: "Se connecter",
  logout: "Déconnexion",
  success: "Succès",
  error: "Erreur",
  warning: "Attention",
  mandatoryField: "Ce champ est obligatoire.",
  mandatoryIntegerField: "Ce champ est obligatoire et doit être un entier.",
  maxLengthField: "Ce champ ne doit pas dépasser {maxLength} caractères.",
  dynamicMandatoryField: "Le champ {field} est obligatoire.",
  dynamicErrorField: "Le champ {field} n'est pas valide.",
  passwordTitle: "Créez votre mot de passe",
  newPasswordTitle: "Renseignez votre nouveau mot de passe",
  mandatoryFieldWithFormat:
    "Ce champ est obligatoire et doit avoir le format requis",
  parameters: "Paramètres",
  search: "Rechercher",
  tableOfContents: "Sommaire",
  train: "S'entraîner",
  assign: "Assigner",
  enterKeyword: "Tape tes mots clés ici…",
  example: "Exemple",
  audioNotSupported: "Votre navigateur ne peut pas lire les fichiers audio.",
  cancel: "Annuler",
  confirmDelete: "Oui, supprimer",
  confirm: "Oui, je confirme",
  close: "Fermer",
  sendUserReminder: "Envoyer une relance",
  saveModification: "Enregistrer les modifications",
  reportBug: "Déclarer un bug",
  screenshot: "Capture d'écran",
  thatIs: "soit le",
  noResult: "Aucun résultat...",
  connectingPleaseWait: "Connexion en cours, veuillez patienter",
  none: "Aucun",
  passwordsDontMatch: "Les mots de passe ne correspondent pas.",
  validate: "Je valide",
  userPersonalData: "Données personnelles",
  comment: "Commentaire",
  level: "Niveau | Niveaux",
  levelUnquantified: "Niveau(x)",
  optional: "facultatif",
  nonStudentAccountAlreadyExists:
    "Un compte de type enseignant existe déjà pour cette adresse email.",
  accountAlreadyExistsBadParams:
    "Assurez-vous d'avoir les bonnes coordonnées de l'élève ; cette adresse mail est déjà utilisée pour un autre élève :",
  duplicateEmail: "Cette adresse email est renseignée plusieurs fois :",
  activationStatus: "Statut",
  startDate: "Date de début",
  endDate: "Date de fin",
  creationDate: "Date de création",
  missingStudentsLevel:
    "Certains étudiants n'ont pas de niveau affecté, ils n'auront pas accès à ce devoir.",
  numberShort: "n°",
  previous: "Précédent",
  next: "Suivant",
  finish: "Terminer",
  nextStep: "Étape suivante",
  previousStep: "Étape précédente",
  yourSelection: "Votre sélection",
  menuBack: "Retourner au menu",
  summary: "Sommaire",
  dynamicModel: "Modèle {modelNumber}",
  instruction: "Consigne",
  instructionImage: "Cliquez sur une image pour l’agrandir.",
  markScale: "Barème",
  proposition: "Proposition | Propositions",
  question: "Question | Questions",
  answer: "Réponse | Réponses",
  part: "Partie | Parties",
  addQuestion: "Ajouter une question",
  addPart: "Ajouter une partie",
  preview: "Prévisualiser",
  helpersActivated:
    "{X} aide(s) activée(s) sur {Y} réponse(s) juste(s). Chaque réponse pour laquelle l’aide a été activée vaut la moitié des points.",
  help: "Aide",
  helpEnabled: "activée. La question vaut la moitié des points.",
  reset: "Reset",
  category: "Catégorie",
  chooseCategory: "Choisissez une catégorie",
  grammar: "Grammaire",
  vocabulary: "Vocabulaire",
  chooseChapter: "Choisissez un chapitre",
  chooseSubchapter: "Choisissez un sous-chapitre",
  position: "Position",
  yes: "Oui",
  no: "Non",
  publishedQuestion: "Publier ?",
  publish: "Publier",
  demoAvailableQuestion: "Disponible en démo ?",
  save: "Sauvegarder",
  update: "Modifier",
  extract: "Extraire",
  published: "Publié",
  saveAndPublish: "Sauvegarder et publier",
  notPublished: "Non publié",
  personalInformation: "Informations personnelles",
  pleaseEnter: "Pour valider, veuillez taper",
  remainingTime: "Temps restant",
  dayShort: "j",
  individual: "Individuel",
  chapters: "Chapitres",
  resetTableOfContent: "Réinitialiser le sommaire",
  status: "Statut",
  activated: "Activé",
  notActivated: "Non activé",
  detail: "Détails",
  delete: "Supprimer",
  message: "Message",
  send: "Envoyer",
  city: "Ville",
  zip: "Code postal",
  address: "Adresse",
  name: "Nom",
  toManyRequests:
    "Vous avez envoyé trop de messages aujourd'hui, réessayez plus tard.",
  messageSent: "Message envoyé.",
  dataContactMessage:
    "Les données recueillies via ce formulaire sont traitées par IIZENGLISH afin de gérer votre demande de contact.",
  dataSubscriptionMessage:
    "Les données recueillies via ce formulaire sont traitées par IIZENGLISH afin de traiter votre inscription sur le site.",
  privacyPolicyMessage:
    "En savoir plus sur la gestion de vos données et vos droits.",
  organization: "Établissement / Organisation",
  filters: "Filtres",
  downloadInPdf: "Télécharger en PDF",
  view: "Visualiser",
  actions: "Actions",
  newContentAvailable: "Une mise à jour est disponible.",
  pleaseRefresh: "Actualiser",
  validationEmailSended:
    "Un nouvel e-mail d’activation de compte vient de vous être renvoyé. Il vous permettra de créer votre mot de passe.",
  checkSpam: "(Pensez à vérifier dans vos courriers indésirables)",
  invitationNotAccepted:
    "Vous avez été invité sur iizenglish mais vous n'avez pas accepté l'invitation qui vous a été envoyée par mail.",
  setPasswordMailResent:
    "Un mail d'invitation vous a été renvoyé. Il vous redirigera vers la création de votre mot de passe et l'activation de votre compte.",
  studentEmailNotDelivered: "Email non délivré",
  checkStudentEmail: "Veuillez vérifier l'adresse mail de l'élève",
  definitiveAction: "Cette action est définitive.",
  irreversible: "Cette action est irréversible.",
  areYouSure: "Êtes-vous sûr ?",
  ALL: "TOUS",
  verify: "Vérifier",
  cookieBannerTitle: "iizenglish et les cookies",
  cookieBannerLegal:
    "En continuant à naviguer sur ce site, vous agréez à l'utilisation de cookies strictement nécessaires au bon fonctionnement du site. Si vous désirez en connaître davantage, cliquez sur ce",
  cookieDetailLink: "lien",
  ok: "D'accord",
  activate: "Activer",
  generate: "Générer",
  numberOfLines: "Nombre de lignes :",
  file: "Fichier :",
  type: "Type",
  understood: "J'ai compris",
  scrollToViewMore: "Faites défiler horizontalement pour voir plus",
  gradingSystem: "Système de notation",
  globalParameter: "Configuration globale",
  parameter: "Paramètre",
  description: "Description",
  value: "Valeur",
  class: _class,
  assignment: _assignment,
  account: _account,
  exercise: _exercise,
  blogs: _blogs,
  form: _form,
  subscription: _subscription,
  schools: _schools,
  notifications: _notifications,
  tabuleoSubscription: _tabuleoSubscription,
  garSubscription: _garSubscription,
  students: _students,
  country: _country,
  teachers: _teachers,
  payment: _payment,
  resource: _resource,
  purge: _purge,
  mockExams: _mockExams,
  twoFactorAuth: _twoFactorAuth,
  session: _session,
  maintenance: _maintenance,
};

export default message;
